import { createPinia } from 'pinia';
import type { Pinia } from 'pinia';

const pinia: Pinia = createPinia()

export default pinia;
